<div id="page_title" class="pageTitle ">
  <h1 [attr.aria-label]="pageTitle">{{pageTitle}}</h1>
</div>
<div id="page_sub_title" class="pageSubtitle " *ngIf="pageSubTitle">
  <p [attr.aria-label]="pageSubTitle" [innerHTML]="pageSubTitle">
  </p>
</div>